import React, { useState, useEffect, useRef } from "react";
import { TextField } from "@material-ui/core";
import useStyles from "./Styles";
import CustomizedSelect from "../common/CustomizedSelect";
import Autocomplete from "@material-ui/lab/Autocomplete";

// Props are being passed down from ChartTitle.js
const CentralAZLocationFilter = ({
  location_options,
  handleChange,
  label,
  style,
  fullWidth,
  city_id,
  autocomplete, // If true the dropdown provides a search bar along with dropdown
}) => {
  const classes = useStyles();
  const isInitialMount = useRef(true);
  const [selectedValue, setSelectedValue] = useState(1);

  const handleSelectedLocation = (e, val) => {
    setSelectedValue(e.target.value);
    handleChange(e.target.value, val?.props?.children);
  };

  useEffect(() => {
    if(!autocomplete && city_id) {
      setSelectedValue(city_id)
    }
  }, [autocomplete, city_id, location_options])

  const handleAutoCompleteLocation = (e, v) => {
    if (v !== null) handleChange(v.value);
  };

  location_options.sort((a, b) => a.label.localeCompare(b.label));

  // useEffect(() => {
  //   if (isInitialMount.current) {
  //     isInitialMount.current = false;
  //   } else {
  //     handleChange(selectedValue);
  //     // console.log("selected value", selectedValue);
  //   }
  // }, [selectedValue]);

  // This is for the public view - to update the location filter to match the other cty dropdowns.

  const setVariable = () => {
    if (selectedValue !== city_id && !isInitialMount.current) {
      setSelectedValue(city_id);
    }
  }
  useEffect(setVariable, [city_id]);

  return (
    // <Box className={classes.locationFilterBox}>
    <div className={classes.mapLocationDiv} style={style}>
      {autocomplete ? (
        // Added Autocomplete component instead of CustomizedSelect since it provides
        // searchbar along with dropdown
        // Check https://asudev.jira.com/browse/CURVE-369 for more info
        <Autocomplete
          id="location-select"
          value={
            location_options.find((location) => location.value === city_id) ||
            {}
          }
          options={location_options}
          getOptionLabel={(option) => option.label || ""}
          onChange={handleAutoCompleteLocation}
          style={{ marginRight: 182}}
          fullWidth={fullWidth}
          renderInput={(params) => (
            <TextField {...params} label={label} variant="outlined" />
          )}
        />
      ) : (
        <CustomizedSelect
          label={label}
          fullWidth={fullWidth}
          dropdownValue={selectedValue}
          options={location_options}
          handleSelectedItem={handleSelectedLocation}
          type="location"
        />
      )}
    </div>

    // </Box>
  );
};

CentralAZLocationFilter.defaultProps = {
  label: "",
  fullWidth: true,
  autocomplete: false,
};


export default CentralAZLocationFilter;



